<script lang="ts">
	import TextInput from './TextInput.svelte'
	import { inputFieldFormats } from '$utils/formatters'
	import { formatLocalized, appendUnit } from '$utils/numberInputFormatters'
	import type { FontProps } from '$types/fontProps'

	export let id: string = ''
	export let value: number | undefined = undefined
	export let format = inputFieldFormats.NORMAL
	export let placeholder: string | number = ''
	export let unit: string = ''
	export let forcedDecimalPlaces: number
	export let borderless: boolean = false
	export let fontProps: FontProps
	export let readOnly: boolean = false
	export let materialWidth: string
	export let materialLabel: string
	export let errorHighlight: boolean = false
	export let clearable: boolean = false

	let inputValue = ''

	$: {
		if (onlyNumbers(placeholder)) {
			if (typeof placeholder === 'string') {
				placeholder = placeholder.replace(/\./g, '')
				placeholder = placeholder.replace(',', '.') // swap so parseFloat reads de-DE
			}
			placeholder = parseFloat(String(placeholder))
				.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
				.replace(',00', '')
		}
		inputValue = formatNumber(value)
	}

	function onlyNumbers(str: string | number): boolean {
		const regex = new RegExp('^[0-9.,]+' + unit + '?$')
		return regex.test(String(str))
	}

	// TODO: IS - 6+ digit grouped values clip in NORMAL (70px) and COMPACT (45px) containers.
	// Pre-existing layout issue (HEAD~1 overflowed by 12px on `100001,00 t`); grouping adds ~3px.
	// Options: widen NORMAL default, auto-promote to FULL when isNumeric+unit, or add overflow handling on TextInput.
	function formatValue(input: string) {
		if (input) {
			const cleaned = input.replace(/[^0-9,]+/g, '')
			const number = parseFloat(cleaned.replace(',', '.'))
			inputValue = appendUnit(
				Number.isNaN(number) ? cleaned : formatLocalized(number, forcedDecimalPlaces),
				unit
			)
			const parsed = parseFloat(inputValue.replace(/\./g, '').replace(',', '.').replace(unit, ''))
			value = Number.isNaN(parsed) ? undefined : parsed
		} else if (input === '') {
			value = undefined
		}
	}

	function formatNumber(numberValue: unknown): string {
		const cleaned = ('' + numberValue).replace(/[^0-9.]+/g, '')
		const number = parseFloat(cleaned)
		return appendUnit(
			Number.isNaN(number) ? cleaned : formatLocalized(number, forcedDecimalPlaces),
			unit
		)
	}
</script>

<TextInput
	{id}
	bind:value={inputValue}
	{format}
	{placeholder}
	{borderless}
	{errorHighlight}
	{fontProps}
	{readOnly}
	{materialWidth}
	{materialLabel}
	{clearable}
	onInputFinished={() => formatValue(inputValue)}
	on:focusout
	on:input
	on:keydown
	on:change
	on:focus
/>
